import { withDispatch, dispatch, withSelect } from '@wordpress/data';
import React from 'react';
import { map } from 'lodash';

import Modal  from "../components/Modal";


function playlistsModal({open}) {
  if (!open) {
    return null;
  }

  return (
    <Modal
      // title=""
    >HI Guys!</Modal>
  );
}

const PlaylistsModal = withSelect((select) => {
  const { getPlaylistsModalOpen } = select("hifi");

  return {
    open: getPlaylistsModalOpen(),
  };
})(playlistsModal);

export default PlaylistsModal;